import { useEffect, useRef, useState } from "react";
import { pubSub } from "../ably";
import { CHANNELS } from "../channel/channels.js";

// A stratcreative message ({ src, enable }) -> the src that is live now, or null.
function srcFrom(msg) {
  if (!msg || typeof msg !== "object") return null;
  return msg.enable === true && typeof msg.src === "string" && msg.src ? msg.src : null;
}

// The creative overlay currently published on the stratcreative channel, or null.
// Same source the viewer app (cme-core VideoPlayerBlock) uses to take over its video
// slot, so the admin's Live Stream card previews exactly what viewers are shown:
// latest message on mount/reconnect + live messages (survives a refresh).
export default function useCreativeSrc() {
  const [src, setSrc] = useState(null);
  const gotLiveRef = useRef(false);

  useEffect(() => {
    let cancelled = false;

    const onMessage = (data, isHistory) => {
      if (!isHistory) gotLiveRef.current = true;
      setSrc(srcFrom(data));
    };

    const loadLatest = async () => {
      try {
        const history = await pubSub.getChannelHistory(CHANNELS.CREATIVE, { limit: 1, maxPages: 1 });
        if (cancelled || gotLiveRef.current) return;
        setSrc(srcFrom(history?.[0]));
      } catch (e) {
        console.warn("[creative] reading stratcreative failed:", e?.message || e);
      }
    };

    pubSub.subscribe(CHANNELS.CREATIVE, onMessage);
    if (pubSub.isConnected) loadLatest();
    const onConnect = (connected) => {
      if (connected) loadLatest();
    };
    pubSub.onConnectionChange(onConnect);
    return () => {
      cancelled = true;
      pubSub.unsubscribe(CHANNELS.CREATIVE, onMessage);
      pubSub.offConnectionChange?.(onConnect);
    };
  }, []);

  return src;
}
